import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-d-c max-size p-3 center-y" }
const _hoisted_2 = { class: "flex-grow-1 center flex-d-c" }
const _hoisted_3 = { class: "pb-3 ion-text-center fw-b" }
const _hoisted_4 = { class: "d-flex pt-3 ion-align-items-end max-width" }
const _hoisted_5 = { class: "d-flex ion-justify-content-evenly max-width" }

import { ref as _ref } from 'vue';

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { chevronBack } from "ionicons/icons";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import InputSimple from "@/components/input/InputSimple.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { RegisterData } from "@/types/functions";
import { useRegister } from "@/composables/viewFunctions/useLogin";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterEmailForce',
  props: {
    registerData: {},
    formInterface: {}
  },
  setup(__props: any) {
const props = __props

const { registerUser } = useRegister()

const confirmEmail = _ref<string>('')

const forceEmailRegister = async () => {
    await registerUser(props.registerData, props.formInterface, true)
    if ((await modalController.getTop())) await modalController.dismiss()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "light-light-background purple-purple-color" }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        "back-button": "",
        title: _ctx.$t('titleRoute.skipEmail')
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('messages.register.skipEmail')), 1),
          _createVNode(InputSimple, {
            modelValue: confirmEmail.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmEmail).value = $event)),
            class: "grey4-grey4-background inherit-background purple-purple-color input-border",
            placeholder: `${_ctx.$t('placeholder.email')}*`,
            debounce: 500
          }, _createSlots({ _: 2 }, [
            (!!confirmEmail.value && confirmEmail.value !== __props.registerData.email)
              ? {
                  name: "error-message",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('error.noMatch', { target: _ctx.$t('placeholder.email') })), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonBase, {
              class: "register-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(modalController).dismiss(undefined, 'cancel')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(ButtonBase, {
              disabled: !confirmEmail.value || confirmEmail.value !== __props.registerData.email,
              class: "register-button",
              onClick: forceEmailRegister
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('button.ok')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})